import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentFetchFailedAction = {
	type: 'DOCUMENT_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentFetchFailedAction => ({
	type: 'DOCUMENT_FETCH_FAILED',
	payload,
});
